import { Component, Host, Prop, h } from '@stencil/core';
import { SizeVariant } from 'src/types';

export type AnchorTarget = '_self' | '_blank' | '_parent' | '_top';

const ALLOWED_TARGETS: AnchorTarget[] = ['_self', '_blank', '_parent', '_top'];

@Component({
  tag: 'sportsline-button',
  styleUrl: 'sportsline-button.css',
  shadow: true,
})
export class SportslineButton {
  /**
   * The button props, the buttonType is the type of the button, the buttonUrl is the URL to be opened when the button is clicked, and the buttonText is the text to be displayed on the button.
   */
  @Prop() variant: string;
  /**
   * The button props, the buttonType is the type of the button, the buttonUrl is the URL to be opened when the button is clicked, and the buttonText is the text to be displayed on the button.
   * This is a required prop.
   * */
  @Prop() href: string;
  /**
   * The button props, the buttonType is the type of the button, the buttonUrl is the URL to be opened when the button is clicked, and the buttonText is the text to be displayed on the button.
   * This is a required prop.
   * */

  @Prop() size?: SizeVariant = 'medium';

  /**
   * If true, the link will open in a new tab.
   * Defaults to false.
   */
  @Prop() target?: AnchorTarget = '_self';

  /**
   * Returns a valid anchor target, falling back to '_self' if not allowed.
   */
  private getValidatedTarget(): AnchorTarget {
    if (this.target && ALLOWED_TARGETS.includes(this.target)) {
      return this.target;
    }
    console.warn(`Invalid target value: ${this.target}. Must be '_self', '_blank', '_parent', '_top', or null.`);
    return '_self';
  }

  render() {
    return (
      <Host>
        <a
          class={{
            'sportsline-button': true,
            'sportsline-button--primary': this.variant === 'primary',
            'sportsline-button--secondary': this.variant === 'secondary',
            'sportsline-button--tertiary': this.variant === 'tertiary',
            'sportsline-button--success': this.variant === 'success',
            'sportsline-button--warning': this.variant === 'warning',
            'sportsline-button--danger': this.variant === 'danger',
            'sportsline-button--small': this.size === 'small',
            'sportsline-button--medium': this.size === 'medium',
            'sportsline-button--large': this.size === 'large',
            'sportsline-button--extra-large': this.size === 'extra-large',
          }}
          href={this.href}
          target={this.getValidatedTarget()}
        >
          <slot />
        </a>
      </Host>
    );
  }
}
